const statusToCN = {
	Completed: 'completed',
	Compose: 'drafted',
	Running: 'active',
	Stopped: 'paused'
} as const

export { statusToCN }
